<template>
  <div class="action-card bg-white action-card-primitive rounded-2 position-relative mb-n6 mx-auto mx-lg-0">
    <div class="p-2 action-card-header bg-white" style="border-radius: 6px">

      <h4 class="m-0">
        <inline-editable-text
          @change="onUpdate({ title: $event })"
          :value="item.title"
          :inline="true"
          :reset-on-update="false"
          :reset-on-cancel="false"
          :lost-focus-is-update="false"
          :is-editable="isEditable"
          />
      </h4>
    </div>

    <div v-if="showConnection" class="workflow-string position-absolute"></div>
  </div>
</template>

<script>
export default {
  props: {
    value: {},
    showConnection: { default: true },
    isEditable: { default: true }
  },
  data: () => ({
    item: {}
  }),
  watch: {
    value: {
      handler( newValue ) {
        this.item = newValue;
      },
      deep: true,
      immediate: true
    },
  },
  methods: {
    onRemove() {
      this.$emit('remove');
    },
  },
  components: {
  }
}
</script>

<style>
</style>
